"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateBandwidthSpeed = calculateBandwidthSpeed;
exports.calculateMinPulseWidthSpeed = calculateMinPulseWidthSpeed;
exports.calculateNelderMeadError = calculateNelderMeadError;
exports.capacitorBasedOnTolerance = capacitorBasedOnTolerance;
exports.checkErrorPercent = checkErrorPercent;
exports.checkToleranceRange = checkToleranceRange;
exports.determineStartingR3R4Value = determineStartingR3R4Value;
exports.frequencyPoint = frequencyPoint;
exports.friendlyFrequency = friendlyFrequency;
exports.resistorBasedOnTolerance = resistorBasedOnTolerance;
exports.sortErrorArray = sortErrorArray;
exports.unjoinArray = unjoinArray;
var _photodiodeConstants = _interopRequireDefault(require("./photodiode-constants"));
var FriendlyFrequency = _interopRequireWildcard(require("./friendlyFrequencies"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function checkToleranceRange(desiredTolerance, desiredValue, toleranceTable) {
  //let finalResistorTolerance = '';
  let toleranceCoerced = false;
  let rowIndex, row;

  //first find the row of desiredTolerance row in table [index]
  for (let i = 0; i < toleranceTable.length; i++) {
    if (toleranceTable[i].tolerance == desiredTolerance) {
      rowIndex = i;
      break;
    }
  }
  if (desiredValue >= toleranceTable[rowIndex].allowedMin && desiredValue <= toleranceTable[rowIndex].allowedMax) {
    //finalResistorTolerance = desiredTolerance;
    row = toleranceTable[rowIndex];
  } else {
    for (let i = rowIndex; i < toleranceTable.length; i++) {
      if (desiredValue >= toleranceTable[i].allowedMin && desiredValue <= toleranceTable[i].allowedMax) {
        row = toleranceTable[i];
        toleranceCoerced = true;
        //finalResistorTolerance = row.tolerance;
        break;
      }
    }
  }
  return [toleranceCoerced, row];
}
function friendlyFrequency(start, end, decade) {
  if (decade <= 0.5) {
    return FriendlyFrequency.generateExtremelyFineGranularityFreqArray(start, end);
  } else if (decade <= 2) {
    return FriendlyFrequency.generateVeryFineGranularityFreqArray(start, end);
  } else if (decade <= 3) {
    return FriendlyFrequency.generateFineGranularityFreqArray(start, end);
  } else {
    return FriendlyFrequency.generateModerateGranularityFreqArray(start, end);
  }
}
function frequencyPoint(startFreq, stopFreq, pointsPerDecade) {
  var x = 10;
  var y = 1 / pointsPerDecade;
  var multiplier = Math.pow(x, y);
  var i = 0;
  var frequency_point = new Array();
  frequency_point[0] = startFreq;
  do {
    frequency_point[i + 1] = frequency_point[i] * multiplier;
    i++;
  } while (frequency_point[i] < stopFreq);
  return frequency_point;
}
function determineStartingR3R4Value(optimization, stageFp) {
  var F_MAX = 10000000;
  var r3plusr4, rMin, rMax, rFreq;
  switch (optimization) {
    case _photodiodeConstants.default.optimizationType.noise:
      rMin = 100;
      rMax = 10000;
      break;
    case _photodiodeConstants.default.optimizationType.voltageRange:
      rMin = Math.sqrt(100000);
      rMax = 100000;
      break;
    case _photodiodeConstants.default.optimizationType.power:
      rMin = 1000;
      rMax = 1000000;
      break;
    case _photodiodeConstants.default.optimizationType.allowedSpecific:
      rMin = Math.sqrt(100000);
      rMax = 1000000;
      break;
    case _photodiodeConstants.default.optimizationType.recommendedSpecific:
      rMin = Math.sqrt(100000);
      rMax = 1000000;
      break;
  }
  var frequency = Math.min(F_MAX, stageFp);
  rFreq = Math.sqrt(F_MAX / frequency) * rMin;
  r3plusr4 = Math.min(rFreq, rMax);
  return r3plusr4;
}
function unjoinArray(joinedArray) {
  var length = joinedArray.length;
  var array1 = [];
  var array2 = [];
  for (var n = 0; n < length; n++) {
    array1.push(joinedArray[n][0]);
    array2.push(joinedArray[n][1]);
  }
  return [array1, array2];
}
function calculateBandwidthSpeed(speedValue) {
  return 2 / speedValue;
}
function calculateMinPulseWidthSpeed(speedValue) {
  return 2 / speedValue;
}
function resistorBasedOnTolerance(desiredValue, desiredTolerance) {
  var toleranceCoerced = false;
  var finalTolerance;
  var nominalValue;
  var resistorArray = [];
  //for error
  var errorOccured = false;
  var errorMessage = '';

  //preferred Series E96,E24
  var arrayE96 = [1, 1.02, 1.05, 1.07, 1.1, 1.13, 1.15, 1.18, 1.21, 1.24, 1.27, 1.3, 1.33, 1.37, 1.4, 1.43, 1.47, 1.5, 1.54, 1.58, 1.62, 1.65, 1.69, 1.74, 1.78, 1.82, 1.87, 1.91, 1.96, 2, 2.05, 2.1, 2.15, 2.21, 2.26, 2.32, 2.37, 2.43, 2.49, 2.55, 2.61, 2.67, 2.74, 2.8, 2.87, 2.94, 2.01, 3.09, 3.16, 3.24, 3.32, 3.4, 3.48, 3.57, 3.65, 3.74, 3.83, 3.92, 4.02, 4.12, 4.22, 4.32, 4.42, 4.53, 4.64, 4.75, 4.87, 4.99, 5.11, 5.23, 5.36, 5.49, 5.62, 5.76, 5.9, 6.04, 6.19, 6.34, 6.49, 6.65, 6.81, 6.98, 7.15, 7.32, 7.5, 7.68, 7.87, 8.06, 8.25, 8.45, 8.66, 8.87, 9.09, 9.31, 9.53, 9.76, 10];
  var arrayE24 = [1, 1.1, 1.2, 1.3, 1.5, 1.6, 1.8, 2, 2.2, 2.4, 2.7, 3, 3.3, 3.6, 3.9, 4.3, 4.7, 5.1, 5.6, 6.2, 6.8, 7.5, 8.2, 9.1, 10];

  //FOR NOW: we declare an object to represent a table (to be moved later) nominalFactor is the number in which we divide desiredValue in order to get it in range of the series check in setNominalValue()
  var resistorTable = [];
  resistorTable.push({
    tolerance: _photodiodeConstants.default.resistorTolerance.ideal,
    allowedMin: _photodiodeConstants.default.Limits.RSMALL_COMP_LIMIT,
    allowedMax: _photodiodeConstants.default.Limits.RBIG_COMP_LIMIT,
    multiplicationFactors: [1],
    preferredSeries: "NA"
  });
  resistorTable.push({
    tolerance: _photodiodeConstants.default.resistorTolerance.oneTenth,
    allowedMin: 10,
    allowedMax: 1000000,
    multiplicationFactors: [0.999, 1.0, 1.001],
    preferredSeries: arrayE96
  });
  resistorTable.push({
    tolerance: _photodiodeConstants.default.resistorTolerance.fiveTenths,
    allowedMin: 10,
    allowedMax: 1000000,
    multiplicationFactors: [0.995, 1.0, 1.005],
    preferredSeries: arrayE96
  });
  resistorTable.push({
    tolerance: _photodiodeConstants.default.resistorTolerance.one,
    allowedMin: _photodiodeConstants.default.Limits.RSMALL_COMP_LIMIT,
    allowedMax: _photodiodeConstants.default.Limits.RBIG_COMP_LIMIT,
    multiplicationFactors: [0.99, 1.0, 1.01],
    preferredSeries: arrayE96
  });
  resistorTable.push({
    tolerance: _photodiodeConstants.default.resistorTolerance.five,
    allowedMin: _photodiodeConstants.default.Limits.RSMALL_COMP_LIMIT,
    allowedMax: _photodiodeConstants.default.Limits.RBIG_COMP_LIMIT,
    multiplicationFactors: [0.95, 1.0, 1.05],
    preferredSeries: arrayE24
  });
  if (desiredValue < _photodiodeConstants.default.Limits.RSMALL_COMP_LIMIT || desiredValue > _photodiodeConstants.default.Limits.RBIG_COMP_LIMIT) {
    //throw up error: the previous functions should never generate a resistor outside of this range
    errorOccured = true;
    errorMessage = 'Resistor should never be outside ' + _photodiodeConstants.default.Limits.RSMALL_COMP_LIMIT + ' and ' + _photodiodeConstants.default.Limits.RBIG_COMP_LIMIT + ' Limit';
  } else {
    var checkResistorRange_result = this.checkToleranceRange(desiredTolerance, desiredValue, resistorTable);
    toleranceCoerced = checkResistorRange_result[0];
    var row = checkResistorRange_result[1];
    finalTolerance = row.tolerance;
    //get nominal value
    nominalValue = setNominalValue(desiredValue, row, false);

    //create resistor array
    for (var i = 0; i < row.multiplicationFactors.length; i++) {
      resistorArray.push(nominalValue * row.multiplicationFactors[i]);
    }
  }
  return [nominalValue, resistorArray, finalTolerance, toleranceCoerced, errorOccured, errorMessage];
}
function capacitorBasedOnTolerance(desiredValue, desiredTolerance) {
  var toleranceCoerced = false;
  var finalTolerance;
  var nominalValue;
  var capacitorArray = [];
  //for error
  var errorOccured = false;
  var errorMessage = '';

  //preferred Series E24,E12,E6
  var arrayE24 = [1, 1.1, 1.2, 1.3, 1.5, 1.6, 1.8, 2, 2.2, 2.4, 2.7, 3, 3.3, 3.6, 3.9, 4.3, 4.7, 5.1, 5.6, 6.2, 6.8, 7.5, 8.2, 9.1, 10];
  var arrayE12 = [1, 1.2, 1.5, 1.8, 2.2, 2.7, 3.3, 3.9, 4.7, 5.6, 6.8, 8.2, 10];
  var arrayE6 = [1, 1.5, 2.2, 3.3, 5.7, 6.8, 10];

  //FOR NOW: we declare an object to represent a table (to be moved later) nominalFactor is the number in which we multiply desiredValue in order to get it in range of the series check in setNominalValue()
  var capacitorTable = [];
  capacitorTable.push({
    tolerance: _photodiodeConstants.default.capacitorTolerance.ideal,
    allowedMin: _photodiodeConstants.default.Limits.CSMALL_COMP_LIMIT,
    allowedMax: _photodiodeConstants.default.Limits.CBIG_COMP_LIMIT,
    multiplicationFactors: [1],
    preferredSeries: "NA"
  });
  capacitorTable.push({
    tolerance: _photodiodeConstants.default.capacitorTolerance.one,
    allowedMin: _photodiodeConstants.default.Limits.CSMALL_COMP_LIMIT,
    allowedMax: 0.0000000048,
    multiplicationFactors: [0.99, 1.0, 1.01],
    preferredSeries: arrayE24,
    nominalFactor: 10000000
  });
  capacitorTable.push({
    tolerance: _photodiodeConstants.default.capacitorTolerance.five,
    allowedMin: _photodiodeConstants.default.Limits.CSMALL_COMP_LIMIT,
    allowedMax: _photodiodeConstants.default.Limits.CBIG_COMP_LIMIT,
    multiplicationFactors: [0.95, 0.97, 1.0, 1.03, 1.05],
    preferredSeries: arrayE24,
    nominalFactor: 10000000
  });
  capacitorTable.push({
    tolerance: _photodiodeConstants.default.capacitorTolerance.ten,
    allowedMin: _photodiodeConstants.default.Limits.CSMALL_COMP_LIMIT,
    allowedMax: _photodiodeConstants.default.Limits.CBIG_COMP_LIMIT,
    multiplicationFactors: [0.9, 0.95, 1.0, 1.05, 1.1],
    preferredSeries: arrayE12,
    nominalFactor: 10000000
  });
  capacitorTable.push({
    tolerance: _photodiodeConstants.default.capacitorTolerance.twenty,
    allowedMin: _photodiodeConstants.default.Limits.CSMALL_COMP_LIMIT,
    allowedMax: _photodiodeConstants.default.Limits.CBIG_COMP_LIMIT,
    multiplicationFactors: [0.8, 0.9, 1.0, 1.1, 1.2],
    preferredSeries: arrayE6,
    nominalFactor: 10000000
  });
  if (desiredValue < _photodiodeConstants.default.Limits.CSMALL_COMP_LIMIT || desiredValue > _photodiodeConstants.default.Limits.CBIG_COMP_LIMIT) {
    //don't attempt to calculate a value
    nominalValue = desiredValue;
    finalTolerance = desiredTolerance;
    return [nominalValue, capacitorArray, finalTolerance, toleranceCoerced, errorOccured, errorMessage];
  } else {
    var checkCapacitorRange_result = this.checkToleranceRange(desiredTolerance, desiredValue, capacitorTable);
    toleranceCoerced = checkCapacitorRange_result[0];
    var row = checkCapacitorRange_result[1];
    finalTolerance = row.tolerance;

    //get nominal value
    nominalValue = setNominalValue(desiredValue, row, true);

    //create capacitor array
    for (var i = 0; i < row.multiplicationFactors.length; i++) {
      capacitorArray.push(nominalValue * row.multiplicationFactors[i]);
    }
  }
  return [nominalValue, capacitorArray, finalTolerance, toleranceCoerced, errorOccured, errorMessage];
}
function calculateNelderMeadError(freqArray, fp, Q, magnitudeValues) {
  var stageMagnitude = [];
  var error;
  var idealMagnitude = [];
  var difference;
  var freqLength = freqArray.length;
  if (fp < 0 || Q < 0) {
    for (let j = 0; j < freqLength; j++) {
      stageMagnitude[j] = 0;
    }
    if (Q < 0) {
      Q = 0;
    }
    if (fp < 0) {
      fp = 0;
    }
    idealMagnitude = stageMagnitude;
  } else {
    //calculate ideal values based on Q & fp
    var num = magnitudeValues[0] * fp * fp;
    for (let j = 0; j < freqLength; j++) {
      var f = freqArray[j];
      var denomReal = fp * fp - f * f;
      var denomImag = f * fp / Q;
      var denomMag = Math.sqrt(denomReal * denomReal + denomImag * denomImag);
      idealMagnitude.push(num / denomMag);
    }
  }

  //now calculate error
  error = 0;
  var stageMaglen = idealMagnitude.length;
  for (var k = 0; k < stageMaglen; k++) {
    difference = magnitudeValues[k] - idealMagnitude[k];
    error = error + difference * difference;
  }
  return error;
}
function checkErrorPercent(fpQErrorObj) {
  var boolErrorArr = false;
  var errArrlen = fpQErrorObj.length;
  var firstError = fpQErrorObj[0].error;
  firstError = fpQErrorObj[0].error * 1.01;
  if (firstError > fpQErrorObj[errArrlen - 1].error) {
    boolErrorArr = true;
  }
  return boolErrorArr;
}
function sortErrorArray(fpQErrorObj) {
  /*sorting the fpQErrorObj according to errorArray*/

  fpQErrorObj.sort(function (obj1, obj2) {
    return obj1.error < obj2.error ? -1 : obj1.error > obj2.error ? 1 : 0;
  }); // sorting the fpQErrorObj array in ascending order according to the value of errorArray
  return fpQErrorObj;
} //end of function

// PRIVATE FUNCTIONS
function setNominalValue(desiredValue, row) {
  var nominalValue, exponent, charAt, row1, row2;
  var desiredVal;
  var nominalVal;

  //convert desiredValue to scientificNotation and a string
  nominalVal = desiredValue.toExponential().toString();

  //remove exponent
  exponent = nominalVal.length;
  charAt = nominalVal.indexOf('e');
  exponent = nominalVal.slice(charAt, exponent);
  nominalVal = parseFloat(nominalVal.slice(0, charAt));
  desiredVal = nominalVal;

  // NOTE : dealing with the case where preferredSeries is NA
  if (row.preferredSeries == "NA") {
    nominalValue = desiredVal;
  } //
  else {
    for (var i = 0; i < row.preferredSeries.length; i++) {
      if (row.preferredSeries[i] <= desiredVal && desiredVal < row.preferredSeries[i + 1]) {
        row1 = desiredVal / row.preferredSeries[i];
        row2 = row.preferredSeries[i + 1] / desiredVal;

        //get closest
        if (row1 < row2) {
          nominalValue = row.preferredSeries[i];
        } else if (row2 < row1) {
          nominalValue = row.preferredSeries[i + 1];
        }
        break;
      }
    }
  }

  //read exponent
  nominalValue = nominalValue.toString() + exponent;
  nominalValue = parseFloat(nominalValue);
  return nominalValue;
}